export enum TeamType {
  STARTER = 1,
  MASTER = 2,
  PRO = 5,
  EDU_STARTER = 6,
  EDU_PRO = 7,
  EDU_EXPERT = 8,
  EDU_GENIUS = 9,
  STUDENT_PRO = 10,
  AUTHOR = 11,
  ENTERPRISE = 12,
  EDU_CAMPUS = 13,
  EDU_360 = 14,
}

const CorpTeamTypes = [
  TeamType.STARTER,
  TeamType.PRO,
  TeamType.MASTER,
  TeamType.AUTHOR,
  TeamType.ENTERPRISE,
] as const;

export type CorpTeamType = (typeof CorpTeamTypes)[number];

export const isCorpTeamType = (teamType: TeamType): teamType is CorpTeamType =>
  CorpTeamTypes.includes(teamType as CorpTeamType);

const EduTeamTypes = [
  TeamType.EDU_STARTER,
  TeamType.EDU_PRO,
  TeamType.EDU_EXPERT,
  TeamType.EDU_GENIUS,
  TeamType.EDU_360,
  TeamType.EDU_CAMPUS,
] as const;

export type EduTeamType = (typeof EduTeamTypes)[number];

export const isEduTeamType = (teamType: TeamType): teamType is EduTeamType =>
  EduTeamTypes.includes(teamType as EduTeamType);
